import * as cmpComponents from './cmp';
import * as plugins from './lego/plugin';
import * as widgets from './widgets';
import * as widgetsScpm from './scpm/widgets';
import * as commonScpm from './scpm/common';
import * as scIcon from './sc/display/scIcon/iconDist';
import * as scComp from './sc';
import * as scpmComponents from './scpm/components';

export default function install(Vue) {
  Object.values(cmpComponents).forEach((component) => {
    Vue.use(component);
  });
  Object.values(plugins).forEach(plugin => {
    Vue.use(plugin);
  });
  Object.values(widgets).forEach(widget => {
    Vue.use(widget);
  });
  Object.values(widgetsScpm).forEach(widget => {
    Vue.use(widget);
  });
  Object.values(commonScpm).forEach(component => {
    Vue.use(component);
  });
  Object.values(scComp).forEach(component => {
    Vue.use(component);
  });
  Object.values(scpmComponents).forEach(component => {
    Vue.use(component);
  });

  for (const iconComponentKey in scIcon) {
    Vue.component(scIcon[iconComponentKey].name, scIcon[iconComponentKey]);
  }
}